import { PDFPage, rgb } from "pdf-lib";
import { Dimension, Margin } from "../types";

export const drawMargin = (
  page: PDFPage,
  margin: Margin,
  dimension: Dimension
) => {
  // TOP
  page.drawLine({
    start: { x: margin.width_offset, y: margin.top_offset },
    end: { x: dimension.width - margin.width_offset, y: margin.top_offset },
    thickness: 1,
    color: margin?.border?.top && margin?.is_active ? rgb(0.8, 0.8, 0.8) : rgb(1, 1, 1),
  });

  // BOTTOM
  page.drawLine({
    start: { x: margin.width_offset, y: margin.bottom_offset },
    end: { x: dimension.width - margin.width_offset, y: margin.bottom_offset },
    thickness: 1,
    color: margin?.border?.bottom && margin?.is_active ? rgb(0.8, 0.8, 0.8): rgb(1, 1, 1),
  });

  // RIGHT
  page.drawLine({
    start: { x: margin.width_offset, y: margin.top_offset },
    end: { x: margin.width_offset, y: margin.bottom_offset },
    thickness: 1,
    color: margin?.border?.right && margin?.is_active ? rgb(0.8, 0.8, 0.8): rgb(1, 1, 1),
  });

  // LEFT
  page.drawLine({
    start: { x: dimension.width - margin.width_offset, y: margin.top_offset },
    end: { x: dimension.width - margin.width_offset, y: margin.bottom_offset },
    thickness: 1,
    color: margin?.border?.left && margin?.is_active ? rgb(0.8, 0.8, 0.8): rgb(1, 1, 1),
  });
};
